<template>
    <form :class="type && type == 'authorizer' ? 'py-0 my-0' : 'py-12'" v-on:submit.prevent="prevent">
        <v-slide-x-transition>
            <v-card class="mx-auto" :class="type && type == 'authorizer' ? 'my-0' : 'my-3'" max-width="600"
                :loading="loading || processing" :disabled="loading || processing">
                <v-card-title class="px-6 pt-6" v-if="type && type == 'authorizer'">
                    Verificamos que você já possui conta conosco!
                </v-card-title>
                <v-card-title class="px-6 pt-6" v-else>
                    {{ $t('auth.recovery.title') }}
                </v-card-title>
                <v-card-subtitle class="px-6">
                    <div v-if="type && type == 'authorizer'">Insira o código que enviamos agora para <strong>{{ user.email
                    }}</strong> e complete seu cadastro!
                    </div>
                    <div v-else v-html="$t('auth.recovery.subtitle', { email: user.email })"></div>
                </v-card-subtitle>
                <v-card-text class="px-6">
                    <div class="mx-16 px-16">
                        <v-otp-input :error-messages="tokenErrors" length="4" v-model="token" :loading="processing"
                            @finish="submit"></v-otp-input>
                        <div class="red--text text-caption" v-for="(err, e) in tokenErrors" :key="e" v-html="err"></div>
                    </div>
                </v-card-text>
                <v-card-actions class="pb-3">
                    <div>
                        <v-btn text class="ma-3 d-block" @click="$emit('setPage', 'password')"
                            v-if="!type || type != 'authorizer'">
                            {{ $t('auth.buttons.back') }}
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-slide-x-transition>
    </form>
</template>
<script>
import axios from 'axios'
export default {

    data: () => ({
        processing: false,
        loading: false,
        token: '',
        tokenInvalid: false,
        tokenRequiredInvalid: false

    }),
    props: {
        user: Object,
        type: {
            required: false,
            type: String
        }
    },
    mounted() {
        this.sendRecoverySteps()
    },
    computed: {

        tokenErrors() {
            const errors = []
            this.tokenRequiredInvalid && errors.push(this.$t('auth.recovery.token.errors.required'))
            this.tokenInvalid && errors.push(this.$t('auth.recovery.token.errors.invalid'))
            return errors
        }
    },
    watch: {
        token(val) {
            if (val) {
                this.tokenInvalid = false
                this.tokenRequiredInvalid = false
            }
            else {
                this.tokenRequiredInvalid = true
            }
        }
    },
    methods: {
        submit() {
            this.processing = true
            axios.create({
                headers: {
                    "Content-Type": "application/json",
                },
                });
            axios.post(`${this.$apiURL}users/token/check`, { token: this.token, type: this.type ? this.type : 'recovery' }).then((response) => {
                console.log('response', response)
                if (response) {
                    if (this.type && this.type == 'authorizer') {
                        this.$emit('responseToken', response.data.data)
                    }
                    else {
                        this.$emit('setToken', this.token)
                    }
                }

                this.processing = false
            }, (err) => {
                this.tokenInvalid = true
                console.error('error', err)
            })
        },
        prevent(event) {
            event.stopPropagation()
        },
        sendRecoverySteps() {
            if (this.user.email) {
                this.loading = true
                axios.post(`${this.$apiURL}users/password/recovery`, { email: this.user.email, type: this.type ? this.type : 'recovery', opt: true, is_publisher: true }).then((response) => {
                    this.loading = false

                    console.log('response', response)
                }, (error) => {
                    console.error('error', error)
                })
            }

        },

    },
}
</script>